import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "../models/authSlice";
import patientReducer from "../models/patientSlice";
import documentDeficiencyReducer from "../models/documentDeficiencySlice";
import navReducer from "../models/navSlice";
import hospitalReducer from "../models/hospitalSlice";
import caseReducer from "../models/casesSlice";
import schemeReducer from "../models/schemeSlice";
import doctorReducer from "../models/doctorSlice";
import referralReducer from "../models/referralSlice";
import healthCareReducer from "../models/healthCareSlice";

import { RESET_STORE } from "./actions";
import roleManagementSlice from "../models/roleManagementSlice";
import visitSlice from "../models/visitSlice";
import schemeOnboardingSlice from "../models/schemeOnboardingSlice";

const appReducer = combineReducers({
  auth: authReducer,
  patients: patientReducer,
  documentDeficiency: documentDeficiencyReducer,
  nav: navReducer,
  hospital: hospitalReducer,
  cases: caseReducer,
  scheme: schemeReducer,
  doctor: doctorReducer,
  referral: referralReducer,
  healthCares: healthCareReducer,
  roleManagement: roleManagementSlice,
  visit: visitSlice,
  schemeOnboarding: schemeOnboardingSlice,
});

const rootReducer = (
  state: ReturnType<typeof appReducer> | undefined,
  action: any
) => {
  if (action.type === RESET_STORE) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
